import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\var\\coverz_ui\\src\\components\\pages\\auth\\register\\register-page.tsx");
